/**
 * @ngdoc service
 * @name home.service:homeManagerSvc
 * @requires $q
 * @requires $window
 * @requires ItxScreenSizeSvc
 * @description
 * Home Selector Service
 */
(function () {
    'use strict';

    angular.module('itxApp.common').service('homeEventManagerSvc', homeSelectorService);

    homeSelectorService.$inject = [
        'ItxErrorMessagesFct',
        'ngDialog',
        '$http',
        '$q',
        'ItxConfigurationSvc',
        'imHomeService',
        'logger',
        'ItxTranslateSvc',
        'ItxHeaderFct',
        'ItxStaticResourceSvc',
        'UserService',
        'NavigationService'
    ];

    function homeSelectorService(
        ItxErrorMessagesFct,
        ngDialog,
        $http,
        $q,
        ItxConfigurationSvc,
        imHomeService,
        logger,
        ItxTranslateSvc,
        ItxHeaderFct,
        ItxStaticResourceSvc,
        UserService,
        NavigationService
    ) {
        //FUNCTION DECLARATION
        var lastStoreJson;

        if (lastStoreJson) {
            lastStoreJson.section = ItxHeaderFct.getLastSection();
        }

        _loadMspotTranslationsAsync(inditex.iStoreId);

        return {
            showNewsletterUnsubscriptionConfirmation: showNewsletterUnsubscriptionConfirmation,
            askNewsletterConfirm: _askNewsletterConfirm,
            askCsbsConfirm: _askCsbsConfirm,
            showSessionExpiredMessage: _showSessionExpiredMessage,
            setSeoHome: _setSeoHome,
            loadCommonTranslationsAsync: _loadCommonTranslationsAsync,
            updateVariablesFromSelectedStore: _updateVariablesFromSelectedStore,
            setHomeVariables: _setHomeVariables,
            setWorldWideVariables: _setWorldWideVariables,
            loadHomeTranslations: _loadHomeTranslations,
            updateHomeStoreJson: updateHomeStoreJson,
            validHomeParams: _validHomeParams,
            updateWorldWideInfo: _updateWorldWideInfo,
            getLastStore: _getLastStore,
            _lastStoreJson: lastStoreJson,
            saveLastStore: saveLastStore,
            removeLastStore: removeLastStore,
            imTriggerHomePageview: imTriggerHomePageview,
            isSessionExpired: _isSessionExpired
        };

        /**
         * @ngdoc method
         * @name _showNewsletterConfirmation
         * @methodOf  home.service:homeManagerSvc
         * @description
         *
         *
         *
         * Mira en el {@link <link> StoreLocatr} que haya tyal cola
         * @param {string} storeId Demo de la descripcion
         * @returns {promise} newsletter unsubscription promise
         *
         */
        function showNewsletterUnsubscriptionConfirmation() {
            inditex.getXconfiguracionValue('NEWSLETTER_DOUBLE_OPT_IN', function (response, value) {
                if (value === '1') {
                    var email = inditex.iUrlJSON.params['email'],
                        fromMyAccount = inditex.iUrlJSON.params['myAccount'] === 'true',
                        hashCode = inditex.iUrlJSON.params['hashValue'];

                    joyr.rest
                        .xRestUnsubscribeToNewsletterConfirmation(email, fromMyAccount, hashCode)
                        .done(function () {
                            var title = ItxTranslateSvc.translateCms(
                                'legacy.ItxNewslettersUnsubscribeSuccessConfirmView.optIn.title'
                            );
                            var text = ItxTranslateSvc.translateCms(
                                'legacy.ItxNewslettersUnsubscribeSuccessConfirmView.optIn.message'
                            );
                            showDialog(title, text);
                            setTimeout(function () {
                                UserService.getCurrentUser(); // lanzamos currentUSer para refrescar los datos de Newsletter.
                            }, 500);
                        })
                        .Catch(function (error) {
                            if (error.errorKey === '_ERR_NEWSLETTER_SUBSCRIPTION_ALREADY_DELETE') {
                                ItxErrorMessagesFct.dialog(
                                    error.errorKey + '.description',
                                    error.errorKey
                                );
                            } else {
                                ItxErrorMessagesFct.dialog(error.errorMessage, error.errorKey);
                            }
                        });
                }
            });
        }

        function _getLastStore(fromWorldWide) {
            if (fromWorldWide) {
                lastStoreJson = JSON.parse(inditex.getLocalStorage('LAST_STORE_GEOBLOCKING'));
                if (!lastStoreJson) {
                    lastStoreJson = JSON.parse(inditex.getLocalStorage('LAST_STORE'));
                } else {
                    lastStoreJson.isGeoblocking = lastStoreJson.saveGeoblockingStore;
                }
            } else {
                var isgeoBlockingEnabled = ItxConfigurationSvc.get('geoblockingEnabled');
                if (isgeoBlockingEnabled) {
                    lastStoreJson = JSON.parse(inditex.getLocalStorage('LAST_STORE_GEOBLOCKING'));
                    if (lastStoreJson) {
                        lastStoreJson.isGeoblocking = lastStoreJson.saveGeoblockingStore;
                    }
                } else {
                    lastStoreJson = JSON.parse(inditex.getLocalStorage('LAST_STORE'));
                }
            }
            return lastStoreJson;
        }

        function _isSessionExpired() {
            return document.location.pathname.indexOf('session-expired.html') > -1;
        }

        /**
         * @ngdoc method
         * @name validHomeParams
         * @methodOf  home.service:homeManagerSvc
         * @description checks if the home params has been set properly
         */
        function _validHomeParams(storeId, langId, section) {
            //Validamos parametros
            var objToValidate = lastStoreJson;
            //Si tiene parametros, validamosd con parametros:
            if (storeId) {
                objToValidate = {
                    storeId: storeId,
                    langId: langId,
                    section: section
                };
            }

            //SI no tiene iStoreId o iLangId  return false
            if (!objToValidate || !objToValidate.storeId || !objToValidate.langId) {
                return false;
            }
            //si tiene homeNewCmsEnabled

            //Checkeamos que tenga sección activa
            if (
                objToValidate.section &&
                ['MEN', 'WOMEN', 'BG'].indexOf(objToValidate.section) > -1
            ) {
                return true;
            } else {
                return false;
            }
        }

        /**
         * @ngdoc method
         * @name askNewsletterConfirm
         * @methodOf  home.service:homeManagerSvc
         * @description shows a stock notification for products with coming soon oar back soon
         */
        function _askNewsletterConfirm() {
            var actionNewsletter = inditex.iUrlJSON.params['newsletterConfirm'];
            var email = inditex.iUrlJSON.params['email'],
                newsletter = inditex.iUrlJSON.params['newsletter'],
                fromMyAccount = inditex.iUrlJSON.params['myAccount'] === 'true',
                hashCode = inditex.iUrlJSON.params['hashValue'];
            if (actionNewsletter === 'alta') {
                joyr.rest
                    .xRestSubscribeToNewsletterConfirmation(
                        email,
                        newsletter,
                        fromMyAccount,
                        hashCode
                    )
                    .done(function () {
                        inditex.writeCookie(
                            'itx-special-event-md',
                            'MASSIMO_DUTTI_PRE_VENTA_FRONT_ACTIVE_TRUE_X98210',
                            1
                        ); // cookie preventa

                        setTimeout(function () {
                            UserService.getCurrentUser().then(function () {
                                UserService.verifyVip()
                                    .then(function (data) {
                                        if (data.isVipSales && data.isVipUser) {
                                            UserService.showVipModal();
                                        } else {
                                            var title = ItxTranslateSvc.translateCms(
                                                'legacy.ItxNewslettersSuccessConfirmView.message1'
                                            );
                                            var text =
                                                ItxTranslateSvc.translateCms(
                                                    'legacy.ItxNewslettersSuccessConfirmView.message2'
                                                ) +
                                                ItxTranslateSvc.translateCms(
                                                    'legacy.ItxNewslettersSuccessConfirmView.message3'
                                                );
                                            showDialog(title, text);
                                        }
                                    })
                                    .catch(function (err) {
                                        console.error(err);
                                        var title = ItxTranslateSvc.translateCms(
                                            'legacy.ItxNewslettersSuccessConfirmView.message1'
                                        );
                                        var text =
                                            ItxTranslateSvc.translateCms(
                                                'legacy.ItxNewslettersSuccessConfirmView.message2'
                                            ) +
                                            ItxTranslateSvc.translateCms(
                                                'legacy.ItxNewslettersSuccessConfirmView.message3'
                                            );
                                        showDialog(title, text);
                                    });
                            });
                        }, 1000);
                    });
            } else {
                joyr.rest
                    .xRestUnsubscribeToNewsletterConfirmation(email, fromMyAccount, hashCode)
                    .done(function () {
                        var title = ItxTranslateSvc.translateCms(
                            'legacy.newsletter_unsubscription_confirm_title'
                        );
                        var text = ItxTranslateSvc.translateCms(
                            'legacy.account_newsletter_unsubscription_confirm_message'
                        );
                        showDialog(title, text);
                        setTimeout(function () {
                            UserService.getCurrentUser();
                        }, 1000);
                    });
            }
        }

        /**
         * @ngdoc method
         * @name askComingSoonBackSoonConfirm
         * @methodOf  home.service:homeManagerSvc
         * @description shows a stock notification for products with coming soon oar back soon
         */
        function _askCsbsConfirm(text) {
            var actionCsbs = inditex.iUrlJSON.params['showCSBSConfirm'],
                op = inditex.iUrlJSON.params['op'],
                email = inditex.iUrlJSON.params['email'],
                hashCode = inditex.iUrlJSON.params['hashValue'];
            if (actionCsbs === 'true') {
                if (op === 'A') {
                    joyr.rest
                        .xRestStockNotificationRequestConfirmation(email, hashCode)
                        .done(function () {
                            var title = ItxTranslateSvc.translateCms(
                                'legacy.ItxNewslettersSuccessConfirmView.message1'
                            );
                            var text =
                                ItxTranslateSvc.translateCms(
                                    'legacy.ItxNewslettersSuccessConfirmView.message2'
                                ) +
                                ItxTranslateSvc.translateCms(
                                    'legacy.ItxNewslettersSuccessConfirmView.message3'
                                );
                            showDialog(title, text);
                        });
                } else if (op === 'B') {
                    joyr.rest.xRestStockNotificationDelete(email, hashCode).done(function () {
                        var title = ItxTranslateSvc.translateCms(
                            'legacy.newsletter_unsubscription_confirm_title'
                        );
                        var text = ItxTranslateSvc.translateCms(
                            'legacy.account_newsletter_unsubscription_confirm_message'
                        );
                        showDialog(title, text);
                    });
                }
            } else {
                if (op === 'A') {
                    joyr.rest
                        .xRestStockNotificationRequestConfirmation(email, hashCode)
                        .done(function () {});
                } else if (op === 'B') {
                    joyr.rest.xRestStockNotificationDelete(email, hashCode).done(function () {});
                }
            }

            if (inditex.iUrlJSON.params['showCSBSConfirm'] === 'true') {
                if (inditex.iUrlJSON.params['op'] === 'A') {
                    ngDialog.open({
                        template: [
                            '<div class="dialog-content">',
                            '  <h2 class="text"',
                            '      ng-bind-html="::ngDialogData.text.ConfirmTitle"></h2>',
                            '  <p  class="text"',
                            '      ng-bind-html="::ngDialogData.text.ConfirmMessage">',
                            '  </p>',
                            '</div>'
                        ].join(''),
                        className: 'ngdialog-theme-plain',
                        showClose: true,
                        data: {
                            text: text
                        }
                    });
                } else if (inditex.iUrlJSON.params['op'] === 'B') {
                    ngDialog.open({
                        template: [
                            '<div class="dialog-content">',
                            '  <h2 class="text"',
                            '      ng-bind-html="::ngDialogData.text.cancellationTitle"></h2>',
                            '  <p  class="text"',
                            '      ng-bind-html="::ngDialogData.text.cancellationMessage">',
                            '  </p>',
                            '</div>'
                        ].join(''),
                        className: 'ngdialog-theme-plain',
                        showClose: true,
                        data: {
                            message: 'Registrado correctamente'
                        }
                    });
                }
            }
        }

        /**
         * @ngdoc method
         * @name _showSessionExpiredMessage
         * @methodOf  home.service:homeManagerSvc
         * @description initializes home metadata for SEO purposes
         */
        function _showSessionExpiredMessage() {
            var title = ItxTranslateSvc.translateCms('legacy.ItxSessionExpiredPage.title');
            var text = ItxTranslateSvc.translateCms('legacy.ItxSessionExpiredPage.text');
            showDialog(title, text, true);
        }

        /**
         * @ngdoc method
         * @name _setSeoHome
         * @methodOf  home.service:homeManagerSvc
         * @description initializes home metadata for SEO purposes
         */
        function _setSeoHome() {
            _loadHomeTranslations.then(function () {
                $('meta[name="description"]').attr(
                    'content',
                    ItxTranslateSvc.translateCms('legacy.ItxHomePage.meta.description')
                );
                $('meta[name="keywords"]').attr(
                    'content',
                    ItxTranslateSvc.translateCms('legacy.ItxHomePage.keywords')
                );
                $('meta[property="og:description"]').attr(
                    'content',
                    ItxTranslateSvc.translateCms('legacy.ItxHomePage.meta.description')
                );
                $('title').html(ItxTranslateSvc.translateCms('legacy.ItxHomePage.title'));
            });
        }

        /**
         * @ngdoc method
         * @name loadPropertiesAsync
         * @methodOf  home.service:homeManagerSvc
         * @description loads translations asynchronously
         */
        function _loadPropertiesAsync(storeId) {
            var url =
                window.staticContent +
                'configurations/properties-' +
                storeId +
                '.js?t=' +
                inditex.iRegistryTs;
            return $http.get(url).then(function (resp) {
                var data = resp.data;
                try {
                    window.configurationContent.properties = eval(data); //jshint ignore:line
                } catch (e) {
                    logger.logError('Error parsing PROPERTIES', e);
                }
            });
        }

        function _loadMspotTranslationsAsync(storeId) {
            let url;

            if(ItxConfigurationSvc.getEnvironment() === 'DEVELOPMENT') {
                url = `/static/configurations/mspot_translations-${storeId}.js?t=${inditex.iRegistryTs}`
            } else {
                url = `${ItxStaticResourceSvc.getStatic()}/configurations/mspot_translations-${storeId}.js?t=${inditex.iRegistryTs}`
            }

            return $http.get(url).then(function (resp) {
                var data = resp.data;
                // debugger
                try {
                    eval(data); // jshint ignore:line
                    window.configurationContent.mspots = eval(data); //jshint ignore:line
                } catch (e) {
                    logger.logError('Error parsing Translations', e);
                }
            });
        }

        /**
         * @ngdoc method
         * @name loadHomeTranslationsAsync
         * @methodOf  home.service:homeManagerSvc
         * @description loads home translations asynchronously
         */
        function _loadHomeTranslationsAsync(langId) {
            return $http
                .get(
                    window.staticContent +
                        '/configurations/homeTranslations' +
                        langId +
                        '.js?t=3' +
                        inditex.iRegistryTs
                )
                .then(function (resp) {
                    var data = resp.data;
                    try {
                        eval(data); // jshint ignore:line
                    } catch (e) {
                        logger.logError('Error parsing MSPOT Translations', e);
                    }
                });
        }

        /**
         * @ngdoc method
         * @name loadCommonTranslationsAsync
         * @methodOf  home.service:homeManagerSvc
         * @description loads common translations asynchronously
         */
        function _loadCommonTranslationsAsync(langId) {
            let url;

            if(ItxConfigurationSvc.getEnvironment() === 'DEVELOPMENT') {
                url = `/static/configurations/commonTranslations${langId}.js?t=${inditex.iRegistryTs}`
            } else {
                url = `${ItxStaticResourceSvc.getStatic()}/configurations/commonTranslations${langId}.js?t=${inditex.iRegistryTs}`
            }

            return $http
                .get(url)
                .then(function (resp) {
                    var data = resp.data;
                    try {
                        eval(data); // jshint ignore:line
                    } catch (e) {
                        logger.logError('Error parsing MSPOT Translations', e);
                    }
                });
        }

        function showDialog(title, text, noLogo) {
            ngDialog.closeAll();
            ngDialog.open({
                template: 'dialog-success.template.html',
                className:
                    'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain  ngdialog-newsletter SESSION EXPIRED',
                showClose: true,
                data: {
                    title: _.capitalize(title),
                    message: text,
                    hideIcon: noLogo
                },
                preCloseCallback: function () {
                    //NavigationService.goToHomePage();
                }
            });
        }

        /**
         * @ngdoc method
         * @name updateVariablesFromSelectedStore
         * @methodOf  home.service:homeManagerSvc
         * @description updates inditex auxiliary variables
         */
        function _updateVariablesFromSelectedStore(prevStoreId, prevLangId) {
            var list0 = inditex.iStoreListJSON.stores;
            var x;
            //CHINA
            if (inditex.iStoreJSON.id === 35009478) {
                document.location.href = x;
                return;
            }
            for (var i = 0; i < list0.length; i++) {
                if (list0[i].id == prevStoreId) {
                    try {
                        if (
                            window.sessionStorage &&
                            window.sessionStorage.getItem('itxGaReferrer') == null
                        ) {
                            window.sessionStorage.setItem('itxGaReferrer', document.referrer);
                        }
                    } catch (e) {}

                    _setHomeVariables();

                    list0[i].isHttpsEnabled = true;

                    x = inditex.encodeStoreUrlWithParams(list0[i], prevLangId, true);

                    inditex.iStoreJSON = list0[i];
                }
            }
            x = x.replace('http:', 'https:');

            if (document.location.hostname === 'localhost') {
                x = x.replace(
                    'https://axpreprueccwpslb1-massimodutti.central.inditex.grp',
                    ItxStaticResourceSvc.getDomain()
                );
            }
            history.pushState({}, null, x);
        }

        /**
         * @ngdoc method
         * @name setHomeVariables
         * @methodOf  home.service:homeManagerSvc
         * @description sets basic page auxiliary variables to render the home page
         */
        function _setHomeVariables() {
            inditex.iPage = 'ItxHomePage';
            inditex.iUrlJSON.action = 'ItxHomePage';
            $('body').attr('id', 'home');
            $('html').attr('id', 'ItxHomePage');
        }

        /**
         * @ngdoc method
         * @name setWorldWideVariables
         * @methodOf  home.service:homeManagerSvc
         * @description sets basic page auxiliary variables to render the worldwide page
         */
        function _setWorldWideVariables() {
            inditex.iPage = 'ItxWorldWidePage';
            inditex.iUrlJSON.action = 'ItxWorldWidePage';
            $('body').attr('id', 'home');
            $('html').attr('id', 'ItxWorldWidePage');
        }

        function _loadI18NAsync(storeId, langId) {
            var url =
                ItxStaticResourceSvc.getWebStandardPath() +
                'js/' +
                storeId +
                '/' +
                langId +
                '/' +
                inditex.iCatalogId +
                '/MD3_ESpot_I18N.min.js?t=' +
                inditex.iRegistryTs;
            return $http.get(url).then(function (resp) {
                var data = resp.data;
                try {
                    eval(data); //jshint ignore:line
                } catch (e) {
                    logger.logError('Error parsing I18N', e);
                }
            });
        }

        function _loadHomeTranslations() {
            var x = inditex.encodeStoreUrlWithParams(inditex.iStoreJSON, inditex.iLangId, true);
            x = x.replace(document.location.origin, '');
            var lastChar = x.substr(-1);
            if (lastChar === '/') {
                x = x.substr(0, x.length - 1);
            }

            return $http.get(x + '/spot.html?spot=homeTranslations').then(function (resp) {
                var data = resp.data;
                data = data.replace(/<!--(.*)-->/g, '');
                data = data.replace('<script type="text/javascript">', '');
                data = data.replace('</script>', '');
                try {
                    eval(data); // jshint ignore:line
                } catch (e) {
                    logger.logError('Error parsing MSPOT Translations', e);
                }
            });
        }

        function updateHomeStoreJson(storeId, langId, countryIso) {
            inditex.iStoreId = storeId;
            inditex.iLangId = langId;
            var deferred = $q.defer();
            var typeCatalog = inditex.iIsMobile ? 5 : 1;
            var storeFound = _.find(inditex.iStoreListJSON.stores, function (storeToFind) {
                return storeToFind.id == storeId;
            });

            inditex.iStoreIdentifier = 'Dutti' + storeFound.countryCode;
            inditex.iCatalogId = storeFound.catalogs[0].id;

            delete inditex.iCategoryTreeJSON;
            delete inditex.iStoreJSON;
            var actions = [];
            actions.push({
                action: 'catalog:categories',
                params: {
                    storeId: storeId,
                    languageId: langId,
                    catalogId: inditex.iCatalogId,
                    typeCatalog: typeCatalog
                }
            });
            var storeAction = {
                action: 'catalog:store',
                params: {
                    storeId: storeId,
                    languageId: langId,
                    catalogId: inditex.iCatalogId,
                    typeCatalog: typeCatalog
                }
            };
            if (countryIso) {
                storeAction.params.countryISO = countryIso;
            }
            actions.push(storeAction);

            actions.push({
                action: 'user:currentUser',
                params: {
                    storeId: storeId,
                    languageId: langId,
                    catalogId: inditex.iCatalogId
                }
            });
            inditex.execute({
                actions: actions,
                onFinish: function () {
                    deferred.resolve();
                }
            });

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name updateWorldWideInfo
         * @methodOf  home.service:homeManagerSvc
         * @description Updates wolrdwide page info
         */
        function _updateWorldWideInfo() {
            ///inditex.iStoreId = storeId;
            //inditex.iLangId = langId;
            var deferred = $q.defer();
            //var typeCatalog = inditex.iIsMobile ? 5 : 1;
            /*var storeFound = _.find(inditex.iStoreListJSON.stores, function(storeToFind) {

                return storeToFind.id == storeId;
            });*/

            //inditex.iStoreIdentifier = 'Dutti' + storeFound.countryCode;
            //inditex.iCatalogId = storeFound.catalogs[0].id;

            //delete inditex.iCategoryTreeJSON;
            //delete inditex.iStoreJSON;
            var actions = [];
            actions.push({
                action: 'catalog:stores',
                params: {
                    brandId: inditex.iBrandId
                }
            });

            actions.push({
                action: 'akamai:location'
            });

            inditex.execute({
                actions: actions,
                onFinish: function () {
                    deferred.resolve();
                }
            });

            return deferred.promise;
        }

        /**
         * @ngdoc method
         * @name saveLastStore
         * @methodOf  home.service:homeManagerSvc
         * @description
         * Creates an object with the given params and calls setLocalStorage.
         * @param {number} storeId Id of the store. Example
         * @param {number} langId Languague ID
         * @param {string} section WOMAN, MAN OR B&G.
         */
        function saveLastStore(storeId, langId, section, saveGeoblockingStore) {
            lastStoreJson = {};
            lastStoreJson.storeId = storeId;
            lastStoreJson.langId = langId;
            lastStoreJson.saveGeoblockingStore = saveGeoblockingStore;

            if(inditex.hybridPage) {
                setLocalStorage(lastStoreJson);
            }
        }

        function setLocalStorage(lastStoreJson) {
            var isgeoBlockingEnabled = ItxConfigurationSvc.get('geoblockingEnabled');
            if (isgeoBlockingEnabled) {
                inditex.setLocalStorage('LAST_STORE_GEOBLOCKING', JSON.stringify(lastStoreJson));
                inditex.removeLocalStorage('LAST_STORE');
            } else {
                inditex.setLocalStorage('LAST_STORE', JSON.stringify(lastStoreJson));
                inditex.removeLocalStorage('LAST_STORE_GEOBLOCKING');
            }
           
        }

        function removeLastStore() {
            var isgeoBlockingEnabled = ItxConfigurationSvc.get('geoblockingEnabled');
            if (isgeoBlockingEnabled) {
                inditex.removeLocalStorage('LAST_STORE_GEOBLOCKING');
            } else {
                inditex.removeLocalStorage('LAST_STORE');
            }
        }

        /**
         * @ngdoc method
         * @name imTriggerHomePageview
         * @methodOf  home.service:homeManagerSvc
         * @description Triggers a pageview
         * @param {object} section woman, man or B&G
         */
        function imTriggerHomePageview(section) {
            section = section || (lastStoreJson && lastStoreJson.section);
            imHomeService.createView(section);
        }

        /**
         * @ngdoc method
         * @name logComponentVisibilityError
         * @methodOf  home.service:homeManagerSvc
         * @description logs console descriptive errors
         * @param {object} componentData object that contains info related to the component
         * @param {string} message received to decide which message to log
         */
        function logComponentVisibilityError(componentData, message) {
            var messages = {
                cover:
                    "Visibility ERROR, element's pageName is missing!!! Please define a pagename for the component:",
                discover:
                    'Visibility ERROR, Discover element pageName is missing!!! Please define a pagename for the component:',
                link:
                    'Visibility ERROR, category link incorrect!!! Please define a valid category link for the component:',
                sliderPageName:
                    "Visibility ERROR, slider element's pageName is missing!!! Please define a pagename for every slide:",
                sliderLink:
                    'Visibility ERROR, slide link incorrect!!! Please define a valid category link for every slide:'
            };

            if (componentData) {
                logger.log(messages[message]);
                logger.log(componentData);
            }
        }
    }
})();
